import React, { Fragment } from 'react'
import Amort from '../finwhale/amort/'
import DefaultBanner from '../finwhale/common/banner/DefaultBanner'
import EuBanner from '../finwhale/common/banner/EuBanner';
import Catalogue from '../finwhale/common/catalogue'
import styled from 'styled-components'
import * as media from '../media'
import Princip from '../finwhale/common/princip'
import TranslateText from 'src/text/modal';
import CurrentLanguageContext from 'src/context/currentLanguageContext';


const ProtectionLabel = styled.div`
  font-size: 24px;
  margin-top: 40px;
  margin-bottom: 40px;
  ${media.smallerThan(1001)`
    margin-left: 0;
    text-align: center;
  `}
`

const NoMobileBanner = styled.div`
  ${media.smallerThan(961)`
    display: none;
  `}
`

const ProtectionTextContainer = styled.div`
  ${media.smallerThan(1001)`
    text-align: center;
  `}
`

const page = () => (
  <div>
    <CurrentLanguageContext.Consumer>
      {currentLanguage => {
        return (
          <Fragment>
            <NoMobileBanner>
              {['en', 'ua'].indexOf(currentLanguage) !== -1 ?
                <EuBanner/>
                :
                <DefaultBanner />
              }
            </NoMobileBanner>

            <Catalogue style={{marginTop: 100,}}/>

            <div style={{width: '80%', margin: '39px auto 0 auto',}}>
              <Princip/>
            </div>

            <div style={{display: 'flex', justifyContent: 'center'}}>
              <div style={{width: '80%'}}>
                <ProtectionLabel>
                  <div style={{fontWeight: 800,}}>
                    <TranslateText id={'main__protection_header'}/>
                  </div>
                </ProtectionLabel>
                <ProtectionTextContainer>
                  <TranslateText id={'main__protection'} useHtml/>
                </ProtectionTextContainer>
                <div style={{marginTop: 40, marginBottom: 20}}>
                  <Amort/>
                </div>
              </div>
            </div>
          </Fragment>
        );
      }}
    </CurrentLanguageContext.Consumer>
  </div>
)

export default page



// WEBPACK FOOTER //
// ./src/pages/index.js